import { type ProductMatrixQueryDto } from '@onrunning/backstage-models';

import type { ProductMatrixApiResponse } from '@/types/matrix.interface';
import { formatMixins } from '../mixins/format.mixins';
import { MatrixType } from '../models/matrix-type.enum';
import { ProductsFilter } from '../models/products-filter.model';
import { ProductsMatrix } from '../models/products-matrix.model';
import { CrudService } from './crud.service';
export class ProductsMatrixService {
  private crudService: CrudService<any>;

  constructor() {
    this.crudService = new CrudService<any>('products-matrix');
  }

  public async getProductsFilters(
    accountId: string,
    matrixType: MatrixType,
    orderDate?: Date,
    orderNumber?: string,
  ): Promise<ProductsFilter[]> {
    const validationResult = await this.crudService.do(
      'get',
      `products-filters/undefined/${matrixType}?accountId=${accountId}${
        orderDate ? `&orderDate=${formatMixins.formatDateToIsoStringIgnoringTime(orderDate)}` : ''
      }${orderNumber ? `&orderNumber=${orderNumber}` : ''}`,
    );

    return validationResult.isValid() ? (validationResult.model as ProductsFilter[]) : new Array<ProductsFilter>();
  }

  public async getProductsMatrix(
    itemGroupNames: string[],
    accountId: string,
    orderDate: Date,
    matrixType: MatrixType,
    collectionNames?: string[],
    orderNumber?: string,
  ): Promise<ProductsMatrix> {
    const productMatrixQuery: ProductMatrixQueryDto = {
      itemGroupNames,
      orderDate: formatMixins.formatDateToIsoStringIgnoringTime(orderDate),
      matrixType,
      collectionNames,
      orderNumber,
    };

    const validationResult = await this.crudService.do('post', `v2?accountId=${accountId}`, productMatrixQuery);

    return validationResult.isValid() ? (validationResult.model as ProductsMatrix) : new ProductsMatrix();
  }

  public async getProductsMatrixV3(
    accountId: string,
    productMatrixQuery: ProductMatrixQueryDto,
  ): Promise<ProductMatrixApiResponse | null> {
    const validationResult = await this.crudService.do(
      'post',
      `v3?accountId=${accountId}`,
      productMatrixQuery,
      undefined,
      'silent',
    );

    return validationResult.isValid() ? validationResult?.model : null;
  }
}
